import IPBoardPart from 'src/app/model/product/ip-board/ip-board-part';
import IPBoardPlacementType, {
  IPBoardPlacementTypeChoices
} from 'src/app/model/product/ip-board/ip-board-placement-type';
import { FloorOption, FloorPickerHelper } from './floor-picker-helper';

export class IPBoardFloorHelper {
  private static readonly BALCONY_STRETCHED_OPTIONS = FloorPickerHelper.FLOOR_OPTIONS.filter(
    o => o.value !== 'Tussen 0 - 1' && o.value !== 'Tussen 1 - 2'
  );
  private static readonly FACADE_OPTIONS = FloorPickerHelper.FLOOR_OPTIONS.filter(
    o => o.value !== null
  );

  private constructor() {}

  public static getFloorOptionsForPlacementType(
    placementType: IPBoardPlacementType
  ): FloorOption[] {
    if (placementType == null) {
      return FloorPickerHelper.FLOOR_OPTIONS;
    }
    if (
      placementType.ordinal === IPBoardPlacementTypeChoices.BALCONY.ordinal ||
      placementType.ordinal === IPBoardPlacementTypeChoices.STRETCHED.ordinal
    ) {
      return this.BALCONY_STRETCHED_OPTIONS;
    }
    if (
      placementType.ordinal ===
      IPBoardPlacementTypeChoices.ATTACHED_TO_FACADE.ordinal
    ) {
      return this.FACADE_OPTIONS;
    }
    return FloorPickerHelper.FLOOR_OPTIONS;
  }

  public static getFloorOptionsForIPBoardPart(
    boardPart: IPBoardPart
  ): FloorOption[] {
    return boardPart == null
      ? FloorPickerHelper.FLOOR_OPTIONS
      : this.getFloorOptionsForPlacementType(boardPart.placementType);
  }
}
